var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: {
      id: _vm.id,
      modalClass: "modal-lg",
      showCloseButton: false,
      headerText: _vm.headerText
    },
    on: { onClose: _vm.handleClose },
    scopedSlots: _vm._u(
      [
        {
          key: "body",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "container-body" },
                [
                  _vm._t("body-top", null, { topBodyProps: _vm.topBodyProps }),
                  _vm._v(" "),
                  _c("CustomMasterDataForm", {
                    attrs: {
                      disabled: _vm.isSubmitting,
                      showCheckboxDefault: _vm.showCheckboxDefault,
                      "master-data-title": _vm.masterDataTitle
                    },
                    model: {
                      value: _vm.input,
                      callback: function($$v) {
                        _vm.input = $$v
                      },
                      expression: "input"
                    }
                  })
                ],
                2
              )
            ]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: { disabled: _vm.isSubmitting, type: "button" },
                  on: { click: _vm.handleClose }
                },
                [_vm._v(_vm._s(_vm.$t("button.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-web",
                  attrs: { disabled: _vm.isSubmitting, type: "button" },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("button.apply")))]
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51b6f8ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b6f8ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalCustomMasterData.vue
// module id = null
// module chunks = 